export const POSITIONS_MANAGER_WIDTH = 260;
export const ICONS_TOOLBAR_WIDTH = 58;
export const PANELS_WIDTH = 226;
export const HEADER_HEIGHT = 53;
export const PINTURA_MAX_MARGIN_LEFT = 174;
export const PINTURA_MAX_MARGIN_RIGHT = 94;
export const BACKGROUND_IMAGE_DPI = 72;
export const BACKGROUND_IMAGE_W = 1000;
export const BACKGROUND_IMAGE_H = 1023;
export const AREA_MARGINS = 10;
export const PREVIEW_IMAGE_BOX = 204;
export const PREVIEW_PRODUCT_BOX = 818;
export const ORDER_DETAILS_WIDTH = 628;
